import { CampaignHistoryItem } from 'ducks/client/customerEvents';

const CAMPAIGN_HISTORY_KEY = 'marketing-campaign-history-v3';
const MAX_HISTORY_ENTRIES = 6;

export const getCampaignHistory = (): CampaignHistoryItem[] => {
  if (typeof window === 'undefined') return [];

  try {
    const stored = localStorage.getItem(CAMPAIGN_HISTORY_KEY);
    if (!stored) return [];

    const history = JSON.parse(stored);
    if (!Array.isArray(history)) return [];

    return history.slice(0, MAX_HISTORY_ENTRIES);
  } catch {
    return [];
  }
};

export const addCampaignToHistory = (
  entry: Omit<CampaignHistoryItem, 'landing_date_time_utc'>
): void => {
  if (typeof window === 'undefined') return;

  try {
    const history = getCampaignHistory();

    // Check if this campaign already exists in recent history (prevent duplicates)
    const isDuplicate = history.some(
      (h) => h.campaign_id === entry.campaign_id && h.content_type === entry.content_type
    );

    if (isDuplicate) return;

    const newEntry: CampaignHistoryItem = {
      ...entry,
      landing_date_time_utc: new Date().toISOString(),
    };

    // Add new entry at the beginning and keep only the latest MAX_HISTORY_ENTRIES
    const updatedHistory = [newEntry, ...history].slice(0, MAX_HISTORY_ENTRIES);

    localStorage.setItem(CAMPAIGN_HISTORY_KEY, JSON.stringify(updatedHistory));
  } catch (error) {
    console.error('Failed to save campaign history:', error);
  }
};

export const clearCampaignHistory = (): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(CAMPAIGN_HISTORY_KEY);
  } catch (error) {
    console.error('Failed to clear campaign history:', error);
  }
};
